module.exports = __webpack_public_path__ + "img/m8m20_thumb.aaeb8a40.jpg";